import { Empty } from 'antd';
import React from 'react';

interface EmptyStateProps {
  viewType: 'booked' | 'pending';
  openModal: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ viewType, openModal }) => {
  return (
    <div className="text-center py-12">
      <Empty
        description={`No ${viewType === 'booked' ? 'scheduled' : 'unscheduled'} meetings`}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />

      {viewType === 'booked' && (
        <button
          onClick={openModal}
          className="mt-4 px-6 py-2.5 bg-btn text-btn-text hover:bg-btn-hover hover:text-btn-hover-text rounded-lg transition-all duration-200 text-sm font-medium"
        >
          Schedule Your First Meeting
        </button>
      )}
    </div>
  );
};

export default EmptyState;
